import React from 'react';

const MarketPanelOptionsTrading = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Options Trading Ideas</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="options-trading">
            <thead>
              <tr>
                <th>Stock Name</th>
                <th>Option Type</th>
                <th>Strike Price</th>
                <th>Current Price</th>
                <th>Change</th>
                <th>% Change</th>
                <th>Volume</th>
                <th>Open Interest</th>
                <th>Implied Volatility</th>
                <th>Expiry Date</th>
                <th>Strategy</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.stock_name || '-'}</td>
                    <td>{item.option_type || '-'}</td>
                    <td>{item.strike_price || '-'}</td>
                    <td>{item.current_price || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.open_interest || '-'}</td>
                    <td>{item.implied_volatility || '-'}</td>
                    <td>{item.expiry_date || '-'}</td>
                    <td>{item.strategy || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelOptionsTrading; 